<template>
  <div class="status-display d-flex flex-column align-items-center">
    {{ message }}

    <div class="text-center p-3">
      <i class="fa fa-check-circle-o fa-5 text-success" v-if="iconType === 'success'"></i>
      <i class="fa fa-times-circle-o fa-5 text-danger" v-if="iconType === 'error'"></i>
      <i class="fa fa-question-circle-o fa-5 text-secondary" v-if="iconType === 'question'"></i>
      <i class="fa fa-info-circle fa-5 text-info" v-if="iconType === 'info'"></i>
      <i class="fa fa-exclamation-circle fa-5 text-warning" v-if="iconType === 'warning'"></i>
    </div>
  </div>
</template>

<script>
const STATUS_ICON_MAP = {
  "報到成功": "success",
  "找不到此活動": "question",
  "報到失敗（報名審核中)": "warning",
  "報到失敗（報名不通過)": "warning",
  "您尚未報名": "error",
  "活動尚未開始": "info",
  "此活動無法報到": "info"
};

export default {
  name: "CheckinStatusDisplay",
  props: {
    message: {
      type: String,
      required: true
    }
  },
  computed: {
    iconType() {
      return STATUS_ICON_MAP[this.message] || 'question';
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../../node_modules/font-awesome/css/font-awesome.min.css";

.status-display {
  width: 100%;
}

.fa-5 {
  font-size: 7rem;
}
</style>
